import React from 'react';

import { InvestImagePanel } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const InvestImagePanelPage = props => (
  <InvestImagePanel {...props} notificationApi={notificationApi} />
);
